import axios from "axios"

const api = axios.create({
    baseURL: "https://api.themoviedb.org/3/",
    params:{
        api_key:"d03845c404baa3661cbd2fe2a42f026a",
        language: "en-US"
    }
});

export const moviesApi = {
    nowPlaying: () =>api.get("movie/now_playing"),
    upcoming: () => api.get("movie/upcoming"),
    popular: () => api.get("movie/popular"),
    // @SEE `movie/${id}`
    movieDetail: (id) => api.get(`movie/${id}`, {params: {append_to_response: "videos"}}),
    movieCrews: (id) => api.get(`movie/${id}/credits`),
    search: (term) => api.get("search/movie", {params: {"query": encodeURIComponent(term)}}),
}

export const tvApi = {
    topRated: () => api.get("tv/top_rated"),
    popular: () => api.get("tv/popular"),
    airingToday: () => api.get("tv/airing_today"),
    tvDetail: (id) => api.get(`tv/${id}`, {params: {append_to_response: "videos"}}),
    tvCrews: (id) => api.get(`tv/${id}/credits`),
    search: (term) => api.get("search/tv", {params: {"query": encodeURIComponent(term)}})
}